import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdministratorEntity } from '../model/administrator/AdministratorEntity';
import { AcademyAdministratorOperation } from '../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/administrator/AcademyAdministratorType';
import { Competition } from '../model/competitions/Competition';
import { CallHttpService } from './call-http.service';

@Injectable({
  providedIn: 'root'
})
export class CompetitionService {

  constructor(private callHttpService: CallHttpService) { }
  sendRequest(entity:AdministratorEntity):Observable<any>{
    let service = entity.type;
    return this.callHttpService.post(`${environment.academyApi.competition}/${service}`,entity);
  }

  updateCompetition(competition: Competition): Observable<any> {
    const entity: AdministratorEntity = {
      type: AcademyAdministratorType.COMPETIIONS,
      operation: AcademyAdministratorOperation.UPDATE,
      payload: competition
    };
    return this.sendRequest(entity);
  }

}
